export default {"src":"/_next/static/media/emc2.d398218f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};